import { SESSION } from '../config/constants';

const KEYS = {
  startTime: 'af_session_start',
  lastActivity: 'af_session_activity',
} as const;

let expiredCallback: (() => void) | null = null;
let intervalId: ReturnType<typeof setInterval> | null = null;

function stopActivityMonitor(): void {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

function startActivityMonitor(): void {
  stopActivityMonitor();
  const events = ['mousedown', 'keydown', 'scroll', 'touchstart'] as const;
  const handler = () => sessionService.recordActivity();
  events.forEach((e) => window.addEventListener(e, handler, { passive: true }));

  intervalId = setInterval(() => {
    if (!sessionService.isSessionValid()) {
      sessionService.endSession();
    }
  }, SESSION.activityCheckIntervalMs);
}

export const sessionService = {
  startSession(): void {
    localStorage.setItem(KEYS.startTime, String(Date.now()));
    localStorage.setItem(KEYS.lastActivity, String(Date.now()));
    startActivityMonitor();
  },

  recordActivity(): void {
    localStorage.setItem(KEYS.lastActivity, String(Date.now()));
  },

  isSessionValid(): boolean {
    return !sessionService.hasExceededMaxDuration() && !sessionService.hasExceededInactivity();
  },

  hasExceededMaxDuration(): boolean {
    const start = localStorage.getItem(KEYS.startTime);
    if (!start) return true;
    return Date.now() - Number(start) > SESSION.maxDurationMs;
  },

  hasExceededInactivity(): boolean {
    const last = localStorage.getItem(KEYS.lastActivity);
    if (!last) return true;
    return Date.now() - Number(last) > SESSION.inactivityMs;
  },

  getTimeRemaining(): number | null {
    const start = localStorage.getItem(KEYS.startTime);
    if (!start) return null;
    const elapsed = Date.now() - Number(start);
    return Math.max(0, SESSION.maxDurationMs - elapsed);
  },

  endSession(): void {
    localStorage.removeItem(KEYS.startTime);
    localStorage.removeItem(KEYS.lastActivity);
    stopActivityMonitor();
    if (expiredCallback) {
      expiredCallback();
    }
  },

  onExpired(callback: () => void): void {
    expiredCallback = callback;
  },

  dispose(): void {
    stopActivityMonitor();
    expiredCallback = null;
  },
};
